export default __webpack_public_path__ + "static/media/vouchers-thumb.8c93ab92.png";